/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationListFilters extends models.RecommendationsFilterBase {
    getFixupPrototypeFunction() { return RecommendationListFilters.fixupPrototype; }

    static newInstance(model: Partial<RecommendationListFilters>): RecommendationListFilters {
        let obj = Object.assign(new RecommendationListFilters(), model);
        RecommendationListFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationListFilters>): RecommendationListFilters {
        if (!model) return null;
        return RecommendationListFilters.newInstance(<RecommendationListFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationListFilters) {
        if (!obj) return;

        models.RecommendationListFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationListFilters): boolean {
        if (models.RecommendationsFilterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationListFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Field represents whether the dashboard is for open or closed
     */
    dashboard_type: models.RecommendationDashboardType;

    /**
     * Search based on resource id, location, hierarchical metadata
     */
    search: string;

}
